import React from "react";
import { getValidLandingScreen } from "../../helpers/utils";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import MilIndicator from "../../components/UI/MIL_pane/MilIndicator";
import DomainProgress from "../../components/UI/Progress_Bar/DomainProgress";
import { useSelector } from "react-redux";
import ErrorAlert from "../../components/UI/ErrorAlert/ErrorAlert";

const SurveyHeader = ({
  description,
  title,
  selectedSurvey,
  showGraphData = true,
}) => {
  const { milData, practicesData, surveyError } = useSelector(
    (state) => state.CRRsurvey
  );
  const history = useHistory();
  const showMeta =
    showGraphData && (Boolean(milData) || Boolean(practicesData));

  return (
    <>
      <ErrorAlert errorData={surveyError} />
      <header className="survey-header">
        <div className="survey-title">
          {!selectedSurvey && (
            <span
              className="left-arrow"
              onClick={() => history.push(getValidLandingScreen())}
            >
              <ArrowLeftOutlined />
            </span>
          )}
          <div className="domain" title={description}>
            <h1 className="domain-title">{title}</h1>
            {description && (
              <p className="domain-description">{description}</p>
            )}
          </div>
        </div>

        {showMeta && (
          <div className="survey-meta">
            {milData && <MilIndicator graphData={milData} />}
            {practicesData && (
              <DomainProgress graphData={practicesData[0]} />
            )}
          </div>
        )}
      </header>
    </>
  );
};

export default SurveyHeader;
